import store from '../../store'
import router from '../../router'
import browser from 'browser-detect'
import Panel from '@/views/Login/Panel.vue'

export default {
   name: 'Login',
   components: {
      Panel
   },
   data() {
      return {
         credentials: {
            user_name: '',
            user_password: ''
         },
         usernameValid: null,
         passwordValid: null,
         wrongCredentials: false,
         loginError: ''
      }
   },
   created() {
      this.detectBrowser()
   },
   mounted() {
      // Shows a logout message for 4sec
      if (localStorage.showLogoutMessage) {
         localStorage.removeItem('showLogoutMessage')
         setTimeout(() => {
            this.$refs.notification.show()
         }, 400)
         setTimeout(() => {
            this.$refs.notification.close()
         }, 4000)
      }
   },
   watch: {
      $route() {
         this.pushOffline()
      }
   },
   methods: {
      detectBrowser() {
         const result = browser()
         console.log(result)
         if (result.name === 'ie' || result.name === 'edge') {
            console.log('This is a safari browser or an iphone.')
            return true
         }
         return false
      },

      selectUsername(selection) {
         this.credentials.user_name = selection
      },
      // On event blur the input for the username gets checked if it is empty
      checkEmptyUsername() {
         if (this.credentials.user_name === '') {
            this.usernameValid = false
         } else {
            this.usernameValid = true
         }
      },
      selectPassword(selection) {
         this.credentials.user_password = selection
      },
      // On event blur the input for the password gets checked if it is empty
      checkEmptyPassword() {
         if (this.credentials.user_password === '') {
            this.passwordValid = false
         } else {
            this.passwordValid = true
         }
      },
      /* Gets called the the user clicks on login button. Gets executed only when inputs are not empty
      Uses the store.js to handle login. When successfull the user gets send to HomeView */
      login() {
         this.checkEmptyUsername()
         this.checkEmptyPassword()
         let emptyCredentials = !this.usernameValid || !this.passwordValid

         if (!navigator.onLine) {
            this.$router.push('/offline')
         }

         if (!emptyCredentials) {
            store
               .dispatch('login', this.credentials)
               .then(() => {
                  // this.checkPrivileges()
                  localStorage.setItem('showLoginMessage', true)
                  location.assign(store.getters.getForwardRoute)
               })
               .catch(err => {
                  this.wrongCredentials = true
                  this.loginError = err
                  console.log(err)
               })
         }
      },

      signUp() {
         router.push({ name: 'SignUp' })
      }
   }
}
